import { QueryClientProvider } from "@tanstack/react-query";
import Watermark from "@uiw/react-watermark";
import { ConfigProvider } from "antd";
import "assets/vendors/style";
import { AuthProvider } from "authentication";
import ScrollToTop from "components/misc/ScrollToTop";
// import NewVersionPrompt from "components/version-prompt";
import App from "containers/App/index";
import { _useAuth } from "hooks";
import { useErrorHandler } from "hooks/useErrorHandler";
import { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "styles/tailwind.css";
import "styles/wieldy.less";
import AppConfig from "utils/Config";
import { isNcdcMode, isProductionMode, isTestMode } from "utils/Constant";
import { queryClient } from "utils/queryClient";
import OfflineBanner from "./components/misc/OfflineBanner";
import { useOnlineStatus } from "./hooks";

if (isProductionMode || isNcdcMode) {
  //isTestMode
  console.log = () => {};
  console.info = () => {};
}

const EnlisApp = () => {
  const { authUser } = _useAuth();

  // Set up global error handler for async errors
  useErrorHandler();

  // CHANGE TITLE ON VISIBILITY CHANGE
  useEffect(() => {
    const _currentTitle = document.title || AppConfig.appName || "";
    document.addEventListener("visibilitychange", () => {
      document.title = document.hidden
        ? `👋🏻 ${authUser?.last_name || ""} ${
            authUser?.first_name || _currentTitle
          }`
        : _currentTitle;
    });

    return () => {
      document.removeEventListener("visibilitychange", () => {
        document.title = _currentTitle;
      });
    };
  }, [authUser]);

  const isOnline = useOnlineStatus();

  const appContent = (
    <ConfigProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={AppConfig.basePath}>
          <AuthProvider>
            <ScrollToTop />
            {!isOnline && <OfflineBanner />}
            <Switch>
              <Route path="/" component={App} />
            </Switch>
            {/* <NewVersionPrompt /> */}
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ConfigProvider>
  );

  return isTestMode ? (
    <Watermark
      content="eN-LIS Test Mode"
      fontSize={10}
      rotate={30}
      gapX={100}
      gapY={300}
      height={5}
      fontColor="rgb(0 0 0 / 10%)"
    >
      {appContent}
    </Watermark>
  ) : (
    appContent
  );
};

export default EnlisApp;
